var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudgetitemRelated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: 60,
    height: 60,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.85) translate(3.5, 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4422 21.5523C33.1683 20.0423 34.7124 19.0001 36.5 19.0001C38.9853 19.0001 41 21.0148 41 23.5001C41 25.9853 38.9853 28.0001 36.5 28.0001C34.7637 28.0001 33.2571 27.0167 32.5067 25.5766M32.4422 21.5523L15.5578 13.4477M32.4422 21.5523C32.1588 22.1417 32 22.8023 32 23.5001C32 24.2491 32.183 24.9553 32.5067 25.5766M15.5578 13.4477C14.8317 14.9577 13.2876 16 11.5 16C9.01472 16 7 13.9853 7 11.5C7 9.01472 9.01472 7 11.5 7C13.5894 7 15.3463 8.42403 15.8529 10.3545C16.122 11.38 16.0176 12.4916 15.5578 13.4477ZM15.4933 34.4235C14.7429 32.9833 13.2363 32 11.5 32C9.01472 32 7 34.0147 7 36.5C7 38.9853 9.01472 41 11.5 41C14.8342 41 17.0033 37.3215 15.4933 34.4235ZM15.4933 34.4235L32.5067 25.5766",
    stroke: "currentColor",
    strokeWidth: 4,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetitemRelated);
export default __webpack_public_path__ + "static/media/budgetitem_related.a60da65e58e80728d52382c3117c6ff8.svg";
export { ForwardRef as ReactComponent };